
import { RouteObject } from 'react-router-dom';
import Home from '../pages/home/page';
import About from '../pages/about/page';
import Services from '../pages/services/page';
import Fulfillment from '../pages/fulfillment/page';
import WMS from '../pages/wms/page';
import Partners from '../pages/partners/page';
import ConsultationPage from '../pages/consultation/page';
import ContactPage from '../pages/contact/page';
import Location from '../pages/location/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/about',
    element: <About />,
  },
  {
    path: '/services',
    element: <Services />,
  },
  {
    path: '/fulfillment',
    element: <Fulfillment />,
  },
  {
    path: '/wms',
    element: <WMS />,
  },
  {
    path: '/partners',
    element: <Partners />,
  },
  {
    path: '/consultation',
    element: <ConsultationPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/location',
    element: <Location />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
